export default "__VITE_ASSET__f8f6789b__"